module.exports = __webpack_public_path__ + "img/a-4.235634a3.jpg";